import React from "react"
import { useIntl } from "react-intl"
import CardStoriesHomePage from "../cards/card-stories-homepage"
import CardVideoHomePage from "../cards/card-video-homepage"
import { language } from "../../i18n"
import CardStoriesHomePageES from "../cards/card-stories-homepage-es"
import CardVideoHomePageES from "../cards/card-video-homepage-es"

const StreamStoriesHomePage = () => {
  const intl = useIntl()
  return (
    <section className="stories stories-homepage">
      <div className="inner inner-stories inner-stories-homepage">
        <div className="stream stream-stories stream-stories-homepage">
          {intl.locale === language.spanish ? (
            <CardStoriesHomePageES />
          ) : (
            <CardStoriesHomePage />
          )}
        </div>
        <div className="stream stream-video stream-stories-video stream-video-homepage">
          {intl.locale === language.spanish ? (
            <CardVideoHomePageES />
          ) : (
            <CardVideoHomePage />
          )}
        </div>
      </div>
    </section>
  )
}

export default StreamStoriesHomePage
